import { getSetRid } from "./getSetRid";
import { API_URL } from "./trackUser";

export const makeGraphqlRequest = (body: Object) => {
    return fetch(API_URL, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-Rid": getSetRid(),
            origin: "https://reonic.de",
        },
        body: JSON.stringify(body),
    });
};
